import instance from './instance';
export default (query) =>
  instance()
    .get('/v3/tags', { params: query || {} })
    .then(({ data: { data } }) => data)
    .catch((err) => err);
